import { createClass as _createClass } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "2e90bShrNpK5I8/g/K9Qv14", "Singleton", undefined);

export function Singleton() {
  var SingletonT = /*#__PURE__*/function () {
    function SingletonT() {}

    _createClass(SingletonT, null, [{
      key: "I",
      get: // protected constructor() {};
      function get() {
        if (SingletonT._I == null) {
          SingletonT._I = new this();
        }

        return SingletonT._I;
      }
    }]);

    return SingletonT;
  }();

  _defineProperty(SingletonT, "_I", void 0);

  return SingletonT;
}

_cclegacy._RF.pop();